import React, {useRef} from 'react'
import PropTypes from 'prop-types'
import {useScroll, useReducedMotion, motion, useTransform} from 'framer-motion'

const MediaAnimation = ({children}) => {
    const ref = useRef(null)
    const shouldReduceMotion = useReducedMotion()
    const {scrollYProgress} = useScroll({
        target: ref,
        offset: ['0 0.8', 'end end']
    })

    const scale = useTransform(scrollYProgress, [0, 1], [shouldReduceMotion ? 1 : 0.7, 1])

    const borderRadius = useTransform(
        scrollYProgress,
        [0, 1],
        [shouldReduceMotion ? '0px' : '12px', '0px']
    )

    return (
        <motion.div ref={ref} style={{scale, borderRadius, overflow: 'hidden'}}>
            {children}
        </motion.div>
    )
}

MediaAnimation.propTypes = {
    children: PropTypes.node
}

export default MediaAnimation
